<template>
  <div>
    <!-- Filters -->
    <TimesheetsFilters
      :status="status"
      :date="date"
      :status-select-disabled="isToValidate"
      @Filter="filter"
    />

    <!-- Results number and order button -->
    <b-row>
      <b-col class="d-flex">
        <p class="font-weight-bold my-auto">{{totalTimesheets}} {{$t($getConst.pages.table.results)}}</p>
        <b-button id="order-button" @click="orderByDate" class="ml-auto" variant="link">
          <AppSvgIcon
            :class="{'d-none': orderRecentFirst}"
            class="text-dark"
            width="2rem" height="2rem"
            :icon="$getConst.svgIcons.sort_num_down"
          />
          <AppSvgIcon
            :class="{'d-none': !orderRecentFirst}"
            class="text-dark"
            width="2rem" height="2rem"
            :icon="$getConst.svgIcons.sort_num_up"
          />
        </b-button>
      </b-col>
    </b-row>

    <hr/>

    <!-- Display timesheets -->
    <b-row>

      <!-- Select and deselect buttons -->
      <b-row v-if="timesheets.length > 0 && isToValidate && isApprover()" class="pb-3">
        <b-col>
          <b-button
            @click="selectAllTimesheets"
            id="select-all-button"
            variant="primary"
            class="mr-2"
          >
            {{$t($getConst.pages.button.select_all)}}
          </b-button>
          <b-button
            v-if="selectedTimesheets.length > 0"
            id="deselect-all-button"
            @click="deselectAllTimesheets"
            variant="primary"
          >
            {{$t($getConst.pages.button.deselect_all)}}
          </b-button>
        </b-col>
      </b-row>

      <!-- Timesheets -->
      <b-row class="w-100">
        <template v-if="totalTimesheets > 0">

          <b-col v-for="timesheet in timesheets" xl="4" lg="6" md="6" class="d-flex align-items-stretch">
            <AppTimesheet
              :country-id="timesheet.CountryID"
              :contract-id="timesheet.ContractID"
              :worker-name="timesheet.WorkerName"
              :company-name="timesheet.CompanyName"
              :unit="timesheet.Units"
              :job-title="timesheet.JobTitle"
              :timesheet="timesheet"
              :is-selected="isTimesheetSelected(timesheet.id)"
              :error="getTimesheetError(timesheet.id)"
              :no-select="!isToValidate || isWorker() || isFreelancer()"
              @click="goToTimesheetDetails"
              @select="selectTimesheet"
            />
          </b-col>

        </template>
        <b-col v-else class="text-center py-5">{{$t($getConst.pages.timesheet.no_timesheet_message)}}</b-col>
      </b-row>

      <!-- Approve all  selected timesheets button -->
      <b-button
        v-if="selectedTimesheets.length > 0 && isToValidate && isApprover() && hasPermission($getConst.permissions.approveTimesheetSummary)"
        variant="primary"
        size="lg"
        class="batch-timesheets-button ml-auto"
        :disabled="isApproving"
        @click="batchApproveTimesheets"
      >
        <AppSpinner v-if="isApproving" class="d-inline-block align-middle"/>
        {{$t($getConst.pages.timesheet.approve_all_timesheet)}} ({{selectedTimesheets.length}})
      </b-button>


    </b-row>

  </div>
</template>

<script>
  import TimesheetsFilters from "./TimesheetsFilters";
  import {batchApproveTimesheet, getTimesheets} from "../../../api/timesheet.api";
  import AppTimesheet from "../../../components/common/timesheet/AppTimesheet";
  import AppSpinner from "../../../components/common/utils/AppSpinner";
  import {formatDate} from "../../../shared/services/date";
  export default {
    name: "TimesheetsList",
    components: {AppSpinner, AppTimesheet, TimesheetsFilters},
    props: {
      isToValidate: {
        type: Boolean,
        default: false
      },
      isLoadingData: {
        type: Boolean,
        default: false
      },
      checkNavApi: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        status: [],
        date: {
          start: null,
          end: null
        },
        timesheets: [],
        orderRecentFirst: true,
        selectedTimesheets: [],
        errorResponseTimesheets: [],
        isApproving: false
      }
    },
    computed: {
      totalTimesheets() {
        return this.timesheets.length;
      }
    },
    methods: {
      initDate() {
        this.date.start = formatDate(new Date(Date.now() - (3*30*24*60*60*1000)));
        this.date.end = formatDate(new Date());
      },
      initStatus() {
        if(!this.isToValidate && (this.isWorker() || this.isFreelancer())) {
          this.status = [
            this.$getConst.timesheetsStatus.submitted,
            this.$getConst.timesheetsStatus.approved,
            this.$getConst.timesheetsStatus.processed
          ];
        } else if(!this.isToValidate && this.isApprover()) {
          this.status = [
            this.$getConst.timesheetsStatus.approved,
            this.$getConst.timesheetsStatus.returned,
            this.$getConst.timesheetsStatus.processed,
            this.$getConst.timesheetsStatus.returnedByHays
          ];
        } else if (this.isToValidate && (this.isWorker() || this.isFreelancer())) {
          this.status = [
            this.$getConst.timesheetsStatus.open,
            this.$getConst.timesheetsStatus.saved,
            this.$getConst.timesheetsStatus.returned,
            this.$getConst.timesheetsStatus.returnedByHays,
          ];
        }else {
          this.status = [
            this.$getConst.timesheetsStatus.submitted,
          ];
        }
      },
      getTimesheets() {
        this.$emit("is-loading-data", true);
        getTimesheets(JSON.parse(sessionStorage.getItem("loggedAs")), this.status, this.date.start, this.date.end).then(
          (response) => {
            this.timesheets = [];
            const contracts = response.data.TimesheetsSummaries;
            contracts.forEach(contract => {
              contract.Timesheets.forEach(timesheet => {
                timesheet.CountryID = contract.CountryID;
                timesheet.ContractID = contract.ContractID;
                timesheet.WorkerName = contract.WorkerName;
                timesheet.CompanyName = contract.CompanyName;
                timesheet.Units = contract.Units;
                timesheet.JobTitle = contract.JobTitle;
                this.timesheets.push(timesheet);
              })
            })
            this.orderByDate();

            this.setTimesheetsInStore(this.$store.state.auth.account, this.timesheets)

            this.$emit("is-loading-data", false);
            this.$emit("check-nav-api", true);
          },
          (error) => {
            this.handleApiError(error);
            this.$emit("is-loading-data", false);
            this.$emit("check-nav-api", false);
          }
        )
      },
      orderByDate() {
        this.orderRecentFirst = !this.orderRecentFirst;
        let self = this;
        this.timesheets.sort(function (a ,b) {
          let dateParts = a.StartDate.split("/");
          const d1 = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
          dateParts = b.StartDate.split("/");
          const d2 = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

          if (self.orderRecentFirst) {
            return d1.getTime() - d2.getTime();
          } else {
            return d2.getTime() - d1.getTime();
          }
        })
      },
      goToTimesheetDetails({timesheetId, navScopeId}) {
        let timesheetStatus = '';
        if(!this.isToValidate && (this.isWorker() || this.isFreelancer())) {
          timesheetStatus = "submitted";
        } else if(!this.isToValidate && this.isApprover()) {
          timesheetStatus = "approved";
        } else if (this.isToValidate && (this.isWorker() || this.isFreelancer())) {
          timesheetStatus = "awaiting_submission";
        }else {
          timesheetStatus = "awaiting_approval";
        }
        this.$router.push(
          {
            name: this.$getConst.routesNames.timesheetDetails,
            params: {
              timesheet_id: timesheetId,
              nav_scope_id: navScopeId,
              timesheet_status: timesheetStatus,
            }
          }
        );
      },
      filter(data) {
        this.status = [...data.status];
        this.date.start = data.fromDate;
        this.date.end = data.endDate;
        this.getTimesheets();
      },

      // Related to batch approve timesheets
      selectedTimesheetIndex(timesheetId) {
        return this.selectedTimesheets.findIndex(element => element.id === timesheetId);
      },
      selectTimesheet({timesheetId, navScopeId}) {
        if (this.isTimesheetSelected(timesheetId)) {
          const index = this.selectedTimesheetIndex(timesheetId);
          this.selectedTimesheets.splice(index,1);
        } else {
          this.addTimesheetToSelectedTimesheets(timesheetId, navScopeId);
        }
      },
      isTimesheetSelected(timesheetId) {
        return this.selectedTimesheetIndex(timesheetId) > -1;
      },
      deselectAllTimesheets() {
        this.selectedTimesheets = [];
      },
      selectAllTimesheets() {
        this.deselectAllTimesheets();
        this.timesheets.forEach(timesheet => {
          this.addTimesheetToSelectedTimesheets(timesheet.id, timesheet.CountryID);
        })
      },
      addTimesheetToSelectedTimesheets(timesheetId, navScopeId) {
        const selectedTimesheet = {
          id: timesheetId,
          countryId: navScopeId,
          languageId: null
        };
        this.selectedTimesheets.push(selectedTimesheet);
      },
      batchApproveTimesheets() {
        this.$emit("is-loading-data", true);
        this.isApproving = true;
        batchApproveTimesheet(this.selectedTimesheets).then(
          (response) => {
            let timesheets = response.data.BatchApproveResponse.Timesheets;
            timesheets.forEach(timesheet => {
              if (timesheet.Error === null) {
                const timesheetIndex = this.timesheets.findIndex(ts => ts.id === timesheet.ID);
                if (timesheetIndex > -1) {
                  this.timesheets.splice(timesheetIndex, 1);
                  this.selectedTimesheets.splice(this.selectedTimesheetIndex(timesheet.ID), 1);
                  return true;
                }
              } else {
                this.errorResponseTimesheets.push(timesheet);
              }
            });
            if (this.errorResponseTimesheets.length > 0) {
              this.$snotify.error(this.$t(this.$getConst.pages.alerts.unknown_error));
            } else {
              this.setTimesheetsInStore(this.$store.state.auth.account);
              this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation), this.$t(this.$getConst.pages.alerts.success));
            }
            this.$emit("is-loading-data", false);
            this.$emit("check-nav-api", true);
            this.isApproving = false;
          },
          (error) => {
            this.handleApiError(error);
            this.$emit("is-loading-data", false);
            this.isApproving = false;
          }
        )
      },
      getTimesheetError(timesheetId) {
        return this.errorResponseTimesheets.find(element => element.ID === timesheetId);
      }
    },
    created() {
      this.initDate();
      this.initStatus();
      this.getTimesheets();
    }
  }
</script>

<style scoped>

</style>
